<template>
    <rkm-modal
        :loading="loading"
        large
        ref="Modal"
        title="Encaminhamento para setor"
    >
        <rkm-form
            ref="Form"
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="centrosCusto"
                        :validations="validations.centroCusto"
                        label="Setor"
                        show-default-option
                        text-field="setorNome"
                        v-model="model.centroCustoId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template
            v-slot:footer="{ cancel }"
        >
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading && disableSaveButton"
                @click="$refs.Form.validate(save)"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        validations() {

            return {
                centroCusto: { required: true },
            }
        }
    },
    data: () => ({
        callback: null,
        model: {
            centroCustoId: null
        },
        disableSaveButton: false
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(callback) {

            this.callback = callback;
            this.model.centroCustoId = null;
            this.disableSaveButton = false;

            this.$refs.Modal.show();

            if (this.$refs.Modal.loading) {
                let timeoutId;


                this.$watch(() => this.$refs.Modal.loading, (newValue) => {
                    if (!newValue) {

                        clearTimeout(timeoutId);

                        this.disableSaveButton = false;
                        this.unsetLoading();
                    }
                });

                timeoutId  = setTimeout(() => {
                    if (this.$refs.Modal.loading) {

                        this.$refs.Modal.hide();

                        this.callback = null;
                        this.disableSaveButton = true;

                        const message = 'O sistema entrou uma falha de comunicação. Deseja atualizar a página e tentar novamente?';

                        this.showAttentionConfirmation(message, () => { window.location.reload() }, () => {});
                    } else {

                        this.disableSaveButton = false;
                    }
                }, 5000);
            }
        },
        save() {

            if (this.model.centroCustoId !== null) {

                this.setLoading()

                this.callback(this.model.centroCustoId)
                    .then(() => this.$refs.Modal.hide())
                    .finally(() => this.unsetLoading())
            }
        },
    },
    props: {
        centrosCusto: { type: Array, required: true },
    }
}
</script>